/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react";
import { HiX } from "react-icons/hi";
import Links from "./componentsrtl/Links";
import "./animation.css";
import SidebarCard from "./componentsrtl/SidebarCard";
// import routes from "../../admin_routes.js";

import { useSelector } from "react-redux";
import axios from "axios";
import { getUserDataByToken } from "proxyUrl";
import { Link } from "react-router-dom";

import { useDispatch } from "react-redux";

import {add} from "store/loggedUserSlice";

const Sidebar = ({ open, onClose, routes }) => {
  // const [navBack, setNavBack] = useState("sidebar-Wrapper");
  const theme = useSelector((state) => state.theme);
  const [user, setUser] = useState("");

  const dispatch = useDispatch();

  const userDataByApi = async () => {
    await axios
      .get(getUserDataByToken, {
        withCredentials: true,
      })
      .then((res) => {
        setUser(res.data.user.userInfo.email);
        dispatch(add(res.data.user));
        
      });
  };
  useEffect(() => {
    if (theme.isDark) {
      // setNavBack("sidebar-WrapperDark")
    } else {
      // setNavBack("sidebar-Wrapper")
    }
  }, [theme.isDark]);

  useEffect(() => {
    userDataByApi();
  }, []);
  return (
    <>
      {user === "andy@creedstaffing.com" ? (
        <>
          <div
            className={`sm:none duration-175 fixed !z-50 m-0 flex min-h-screen flex-col overflow-hidden bg-gradient-to-b from-indigo-600 via-indigo-600 to-indigo-700 px-0 py-4 transition-all dark:bg-gradient-to-b dark:from-indigo-800 dark:via-indigo-800 dark:to-indigo-900 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
              open ? "translate-x-0" : "-translate-x-96"
            }`}
            style={{ width: '200px' }}
          >
            <span
              className="absolute top-3 right-3 block cursor-pointer text-white/90 hover:text-white transition-colors xl:hidden z-10"
              onClick={onClose}
            >
              <HiX className="h-4 w-4" />
            </span>
            <div className="mt-1 mb-4 flex items-center justify-center px-3">
              <img
                className="h-12 w-auto"
                src="/logocr.png"
                alt="Logo"
                width={180}
              />
            </div>
            {/* Nav item */}
            <ul className="mb-auto pt-0 space-y-0.5 px-2">
              <Link to={"/admin/dashboard"} className="relative flex items-center gap-3 px-3 py-2.5 text-sm font-normal text-white hover:bg-white/10 transition-all duration-150">
                <svg className="h-5 w-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
                Dashboard
              </Link>
              <Link to={"/admin/jobs"} className="relative flex items-center gap-3 px-3 py-2.5 text-sm font-normal text-white hover:bg-white/10 transition-all duration-150">
                <svg className="h-5 w-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                All Jobs
              </Link>
              <Link to={"/auth/sign-out"} className="relative flex items-center gap-3 px-3 py-2.5 text-sm font-normal text-white hover:bg-white/10 transition-all duration-150">
                <svg className="h-5 w-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
                Logout
              </Link>
            </ul>
          </div>
        </>
      ) : (
        <>
          <div
            className={`sm:none duration-175 fixed !z-50 m-0 flex min-h-screen flex-col overflow-hidden bg-gradient-to-b from-indigo-600 via-indigo-600 to-indigo-700 px-0 py-4 transition-all dark:bg-gradient-to-b dark:from-indigo-800 dark:via-indigo-800 dark:to-indigo-900 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
              open ? "translate-x-0" : "-translate-x-96"
            }`}
            style={{ width: '200px' }}
          >
            <span
              className="absolute top-3 right-3 block cursor-pointer text-white/90 hover:text-white transition-colors xl:hidden z-10"
              onClick={onClose}
            >
              <HiX className="h-4 w-4" />
            </span>
            <div className="mt-1 mb-4 flex items-center justify-center px-3">
              <img
                className="h-12 w-auto"
                src="/logocr.png"
                alt="Logo"
                width={180}
              />
            </div>
            {/* Nav item */}
            <ul className="mb-auto pt-0 space-y-0.5 px-2">
              <Links routes={routes} />
            </ul>
            {/* Nav item end */}
            {/* <div className="navbar-flight absolute top-[73%] left-0 mx-auto flex h-[200px] w-[100%]  items-center justify-center p-4">
              <div className=" mx-auto h-full w-full    rounded-xl">
                {" "}
                <img
                  src="/myimage.png"
                  className=" h-full w-full object-cover"
                  alt=""
                />
              </div>
            </div> */}
            <div className="area -z-3 absolute left-0 top-0 h-full w-full ">
              <ul className="circles">
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
              </ul>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Sidebar;
